
import IconButtonBase from 'components/UI/IconButtonBase';
import AccountCircleIcon from 'public/assets/svgs/icons/account-circle.svg';

const AccountCircleIconButton = props => (
  <IconButtonBase {...props}>
    <AccountCircleIcon />
  </IconButtonBase>
);

export default AccountCircleIconButton;
